export const URL_PANORAMA_UBANO =
	"https://panoramaurbano.barranquilla.gov.co:7890/";